import { combineEpics } from "redux-observable";
import { epicPVPAddUnits } from "./epics/epicPVPAddUnits";
import { epicPVPInfoRequest } from "./epics/epicPVPInfoRequest";
export var epicPVP = combineEpics(epicPVPInfoRequest, epicPVPAddUnits);



//////////////////
// WEBPACK FOOTER
// ./src/features/pvp/epicPvp.ts
// module id = 2106
// module chunks = 3